import MyDocument from './Minmax';
import { isMobile } from 'react-device-detect';
import { createContext, useContext, Children, cloneElement, React, useState, useEffect, useRef } from "react";

import { saveAs } from "file-saver";
import { PDFDownloadLink, PDFViewer, pdf, BlobProvider, usePDF } from '@react-pdf/renderer';
// import { Button } from 'antd';
// const reactPdf = require('react-pdf/dist/esm/entry.webpack5')
// const { Document, Page } = reactPdf

// import { Document, Page, pdfjs } from 'react-pdf/dist/esm/index.webpack5';
import { Document, Page, pdfjs } from "react-pdf";
import pdfjsWorker from "react-pdf/node_modules/pdfjs-dist/build/pdf.worker.entry";
import { Button, Paper, Typography, CircularProgress, Box } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import FileDownloadOffIcon from '@mui/icons-material/FileDownloadOff';
import IconButton from '@mui/material/IconButton';
import folderImg from '../Pictures/folder.jpg';        //最ＯＫ
import { injectIntl, intlShape, useIntl, FormattedMessage, IntlProvider } from 'react-intl';
import { Provider, useDispatch, useSelector } from "react-redux";
import app_reducers from "../reducers/app";
import { configureStore } from '@reduxjs/toolkit'
import logger from "redux-logger";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;// import { Document, Page, setOptions, pdfjs } from 'react-pdf';
// import url from "pdfjs-dist/build/pdf.worker";

// pdfjs.GlobalWorkerOptions.workerSrc = url;

const Loading = () => {
    const intl = useIntl();

    return (
        <Paper elevation={3} style={{ height: 300, width: '100%' }}>

            <Typography>{intl.formatMessage({ id: "下載中，圖片較多請耐心等候" })}</Typography>
            <Typography>{intl.formatMessage({ id: "LINE內建之瀏覽器將無法正常下載" })}</Typography>
            <Typography>{intl.formatMessage({ id: "下載速度受網路速度影響" })}</Typography>
            <Box style={{ padding: 20 }}>
                <CircularProgress />
            </Box>
        </Paper>)
}

// const pdfjs = require('pdfjs-dist');
// pdfjs.PDFJS. = '/js/pdf.worker.js'
// import { Document, Page } from 'react-pdf/dist/umd/entry.webpack';
const App = (props) => {
    const { Array02, items, Profile, Array03, Array04, Array06, GaugeItem, PicObj, Array02_1, Array02_2, subItems, seturl } = props;
    const { app, i18n } = useSelector(state => ({
        i18n: state.app.i18n,
    }));
    const intl = useIntl();

    // const generatePDFDocument = async () => {
    //     const blob = await pdf(
    //         <MyDocument />
    //     ).toBlob();

    //     console.log(blob);

    //     saveAs(blob, "pageName");
    // };

    // const generatePdfDocument = async (MyDocument, fileName) => {
    //     const blob = await pdf((
    //         <MyDocument
    //             title='My PDF'
    //         // pdfDocumentData={MyDocument}
    //         />
    //     )).toBlob();
    //     saveAs(blob, fileName);
    // };
    // const blob = pdf((
    //     <MyDocument
    //         title='My PDF'
    //     // pdfDocumentData={MyDocument}
    //     />
    // )).toBlob();
    // // const [numPages, setNumPages] = useState(null);
    // const [pdfString, setPdfString] = useState('');
    // const [numPages, setNumPages] = useState(null);
    // const [pdfString, setPdfString] = useState('');
    // const [numPages, setNumPages] = useState(null);
    // const [pageNumber, setPageNumber] = useState(1);

    // const onDocumentLoadSuccess = ({ numPages }) => {
    //     setNumPages(numPages);
    // };

    // let base64String;

    // let reader = new FileReader();
    // reader.readAsDataURL(blob);
    // reader.onloadend = () => {
    //     base64String = reader.result;
    //     setPdfString(base64String.substr(base64String.indexOf(',') + 1));
    // };
    // return (
    //     <div>
    //         <BlobProvider document={<MyDocument />}>
    //             {({ blob, url, loading }) => {
    //                 console.log(url)
    //                 console.log(blob)

    //                 // let base64String;

    //                 // let reader = new FileReader();
    //                 // reader.readAsDataURL(blob);
    //                 // reader.onloadend = () => {
    //                 //     base64String = reader.result;
    //                 //     setPdfString(base64String.substr(base64String.indexOf(',') + 1));
    //                 // };
    //                 return loading ? 'loading' : (
    //                     <Document
    //                         file={url}
    //                         onLoadSuccess={onDocumentLoadSuccess}
    //                         // renderMode="canvas"
    //                         onLoadError={console.error}>
    //                         <Page pageNumber={pageNumber}
    //                             width={window.innerWidth} />
    //                     </Document>
    //                     // <iframe src={url}></iframe>
    //                 );
    //             }}
    //         </BlobProvider>
    //     </div>)
    // console.log(Array02_1)
    // console.log(Array02)
    // console.log(Array02_2)


    if (isMobile) {
        // generatePdfDocument(MyDocument, '222')

        // function onDocumentLoadSuccess({ numPages }) {
        //     setNumPages(numPages);
        // }
        return (
            <PDFDownloadLink
                document={
                    <IntlProvider locale={i18n.locale} messages={i18n.messages}>
                        <MyDocument Array02={Array02} items={items} Profile={Profile} Array03={Array03} Array04={Array04}
                            Array06={Array06} GaugeItem={GaugeItem} PicObj={PicObj} Array02_1={Array02_1} Array02_2={Array02_2} subItems={subItems} i18n={i18n} />
                    </IntlProvider>
                }
                fileName={Profile.PersonalId + '_' + Profile.UserName}
            >   
                {({ blob, url, loading }) => {
                    
                    // console.log(loading)
                    // console.log(url)
                    // console.log(blob)
                    if (blob !== null) {
                        console.log(blob)

                        if (blob.size > 1108807) {
                            // console.log(blob)
                            var blob2 = new Blob([blob], { type: 'application/octet-stream' });
                            return (
                                <>
                                    <a href={url} download={Profile.PersonalId + '_' + Profile.UserName +" " +i18n.locale + '.pdf'} style={{ position: "absolute", zIndex: 1, top: 0, left: 0 }}>
                                        <IconButton >
                                            <GetAppIcon style={{ color: "white" }} />
                                        </IconButton>
                                    </a>
                                    
                                    <Paper elevation={3} style={{ height: 300 }}>
                                        <Typography>{intl.formatMessage({ id: "請用chrome或safari瀏覽器下載" })}</Typography>
                                        <Button variant='contained' color='success' onClick={(e) => {
                                            e.preventDefault();
                                            saveAs(blob2, Profile.PersonalId + '_' + Profile.UserName  + '.pdf')
                                        }} >下載</Button>
                                        <Typography>{intl.formatMessage({ id: "如報告下載異常，請改用非手機之瀏覽器下載" })}</Typography>
                                        <Typography>{intl.formatMessage({ id: "手機下載後，將會自動存放在“檔案app”內（如下圖所示）" })}</Typography>
                                        <img src={folderImg} style={{ width: 100, height: 100 }}></img>

                                    </Paper>
                                </>
                            )
                        }
                        else {
                            // console.log(blob)

                            return <Loading />


                        }


                    } else {

                        return <Loading />
                    }

                }
                }
            </PDFDownloadLink>

        )

        // );
    } else {
        return (
            // <PDFViewer
            //     // style={{ width: '100%', height: '100vh' }}
            //     style={{ position: 'absolute', border: 0, height: '95%', width: '100%' }}
            // >

            //     <MyDocument Array02={Array02} items={items} Profile={Profile} Array03={Array03} Array04={Array04}
            //         Array06={Array06} GaugeItem={GaugeItem} PicObj={PicObj} Array02_1={Array02_1} Array02_2={Array02_2} subItems={subItems} />
            // </PDFViewer>
            <BlobProvider document={
                <IntlProvider locale={i18n.locale} messages={i18n.messages}>
                    <MyDocument Array02={Array02} items={items} Profile={Profile} Array03={Array03} Array04={Array04}
                        Array06={Array06} GaugeItem={GaugeItem} PicObj={PicObj} Array02_1={Array02_1} Array02_2={Array02_2} subItems={subItems} i18n={i18n} />
                </IntlProvider>
            }
            >
                {({ blob, url, loading }) => {
                    // console.log(loading)
                    // console.log(blob)

                    if (blob !== null) {
                        console.log(blob)
                        if (blob.size > 1108807) {
                            // console.log(blob)
                            return (
                                <>
                                    <a href={url} download={Profile.PersonalId + '_' + Profile.UserName + " " +i18n.locale + '.pdf'} style={{ position: "absolute", zIndex: 1, top: 0, left: 0 }}>
                                        <IconButton >
                                            <GetAppIcon style={{ color: "white" }} />
                                        </IconButton>
                                    </a>
                                    <iframe style={{ width: '100%', height: '100vh' }} src={url}  ></iframe>

                                </>)
                        } else {
                            return <Loading />

                        }
                    } else {
                        return <Loading />

                    }
                }}
            </BlobProvider>

        );
    }



}

export default App
